import { render, staticRenderFns } from "./piweb-rodape.vue?vue&type=template&id=c803289c&scoped=true"
import script from "./piweb-rodape.vue?vue&type=script&lang=js"
export * from "./piweb-rodape.vue?vue&type=script&lang=js"
import style0 from "./piweb-rodape.vue?vue&type=style&index=0&id=c803289c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c803289c",
  null
  
)

export default component.exports